import {
  AccessTimeRounded,
  AutoFixHigh as AutoFixHighIcon,
  AutoFixOff as AutoFixOffIcon,
} from '@mui/icons-material'
import { Stack, Tooltip, Typography } from '@mui/material'

const isBoolean = (value) => value === true || value === false

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.params
 * @param {Object} props.params.row
 * @param {string} [props.params.formattedValue]
 * @param {Object} props.reasonsById
 * @param {boolean} [props.mobileView]
 */
export default function EventListNetChargeCell({ params, reasonsById, mobileView }) {
  const { row, formattedValue } = params
  const isAutochargePending =
    row.smokeFeedback?.autochargeMetadata?.chargeStatus === 'pending'

  return (
    <Stack>
      <Stack direction="row" justifyContent="right">
        {isAutochargePending && (
          <Tooltip title="Auto-charge pending">
            <AccessTimeRounded
              fontSize="small"
              sx={{ mr: 1, fontSize: mobileView ? 16 : 20 }}
              color="warning"
            />
          </Tooltip>
        )}
        {isBoolean(row.smokeFeedback?.autocharge) &&
          (row.smokeFeedback.autocharge ? (
            <Tooltip title="Auto-charge successful">
              <AutoFixHighIcon fontSize="small" sx={{ mr: 1 }} color="success" />
            </Tooltip>
          ) : (
            <Tooltip title="Auto-charge failed">
              <AutoFixOffIcon fontSize="small" sx={{ mr: 1 }} color="error" />
            </Tooltip>
          ))}
        <Typography
          variant={mobileView ? 'caption' : 'body1'}
          fontSize={mobileView ? 12 : 14}
        >
          {formattedValue}
        </Typography>
      </Stack>
      <Typography
        variant="caption"
        fontSize={mobileView ? 10 : 12}
        color="grey.500"
        align="right"
      >
        {reasonsById?.[row.smokeFeedback?.adjustmentReason] ?? ''}
      </Typography>
    </Stack>
  )
}
